<template>
  <!-- dashboard-content-area-start -->
  <div class="tpd-content-layout">

    <!-- dashboard-tab-area -->
    <div class="tp-dashboard-tab mb-30">
      <div class="d-flex align-items-center">
        <template v-if="show_details">
          <h2 class="tp-dashboard-tab-title border-0 m-0">
            <a class="pointer-event" @click="show_details=false">{{ lms_website.__('My Tickets') }}</a>
            <span class="mx-2">|</span>
            <small class="text-secondary">{{ tickets.details?.name }}</small>
          </h2>
          <div class="ms-auto me-3" v-if="isStudent">
            <button type="button" @click="refreshTicket(tickets.details?.name)" class="btn btn-sm btn-outline-secondary"><i class="fas fa-sync-alt"></i></button>
          </div>
        </template>
        <template v-else>
          <h2 class="tp-dashboard-tab-title border-0 m-0"> {{ lms_website.__('My Tickets') }} </h2>
          <div class="ms-auto me-3" v-if="isStudent">
            <button type="button" @click="refreshTickets" class="btn btn-sm btn-outline-secondary me-2"><i class="fas fa-sync-alt"></i></button>
            <button type="button" @click="newTicket" class="btn btn-sm btn-primary"><i class="fas fa-plus me-1"></i> {{ lms_website.__('New Ticket') }}</button>
          </div>
        </template>
      </div>
    </div>
    <!-- dashboard-tab-area-end -->
    <div class="tpd-table mb-25">
      <table class="table table-sm table-hover table-bordered tickets-table" v-if="!show_details">
        <thead>
        <tr>
          <th style="width:150px;" scope="col"> {{ lms_website.__('Ticket ID') }}</th>
          <th scope="col"> {{ lms_website.__('Ticket Subject') }}</th>
          <th style="width:150px;" scope="col"> {{ lms_website.__('Type') }}</th>
          <th scope="col"> {{ lms_website.__('Status') }}</th>
          <th style="width:80px;" scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr class="pointer-event" @click="openTicket(row.name)" v-for="row in paginatedTickets" :key="row.id" v-if="!tickets.loading">
          <td><a class="text-primary">{{ row.name }}</a></td>
          <td><a class="text-dark font-s-13" style="line-height: 18px;">{{ row.subject }}</a></td>
          <td><span class="font-s-13">{{ row.ticket_type }}</span></td>
          <td>
            <div class="badge text-bg-secondary" :data-status="row.workflow_state">{{ lms_website.__(row.custom_request_type) }}</div>
          </td>
          <td class="text-center"><span class="d-inline-block" :tooltip="moment(row.creation).format('YYYY-MM-DD (HH:mm) A')"><i class="far fa-clock me-1"></i> {{ frappe.datetime.prettyDate(row.creation, true) }}</span></td>
        </tr>
        <tr>
          <td colspan="5" class="text-center" v-if="tickets.loading">
            <div class="spinner-border mt-2" role="status">
              <span class="sr-only">{{ lms_website.__('Loading') }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="5" class="text-center" v-if="!tickets.loading && !tickets.list.length">
            {{ lms_website.__('No tickets found') }}
          </td>
        </tr>
        </tbody>
      </table>
      <template v-if="show_details">
        <template v-if="show_details_loading">
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">{{ lms_website.__('Loading') }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <h5 class="mb-3 d-flex align-items-center">
            {{ tickets.details?.subject }}
            <span class="badge text-bg-secondary ms-auto" :data-status="tickets.details?.workflow_state">{{ lms_website.__(tickets.details?.workflow_state) }}</span>
          </h5>
          <hr>
          <div class="d-flex align-items-center gap-3">
            <span class="font-s-13"><i class="far fa-folder me-1"></i> {{ tickets.details?.custom_ticket_name }}</span>
            <span class="font-s-13"><i class="far fa-folder-open me-1"></i> {{ tickets.details?.custom_ticket_type }}</span>
            <span class="font-s-13 ms-auto" :tooltip="moment(tickets.details?.creation).format('YYYY-MM-DD (HH:mm) A')"><i class="far fa-clock me-1"></i> {{ frappe.datetime.prettyDate(tickets.details?.creation, true) }}</span>
          </div>
          <hr>
          <div v-html="tickets.details?.description"></div>
          <div class="mt-3" v-if="tickets.details?.custom_attach">
            <hr>
            <h6>{{ lms_website.__('Attachments') }}:</h6>
            <a :href="tickets.details?.custom_attach" class="btn btn-sm btn-light" target="_blank"> <i class="far fa-file me-1"></i> {{ getAttachmentFileName(tickets.details?.custom_attach) }}</a>
          </div>
          <div class="mt-4">
            <div class="card m-0">
              <div class="card-header d-flex align-items-center">
                <h5 class="m-0">{{ lms_website.__('Comments ({0})', [tickets.details?.comments?.length]) }}</h5>
                <div class="ms-auto">
                  <button type="button" class="btn btn-sm btn-primary" @click="newComment"><i class="fas fa-reply me-1"></i> {{ lms_website.__('Reply') }}</button>
                </div>
              </div>
              <template v-if="!tickets.details?.comments?.length">
                <div class="text-center pt-3">
                  {{ lms_website.__('No comments found') }}
                </div>
              </template>
              <div class="card-body pb-1">
                <div class="card p-3 mb-3 animate__animated" style="background:#fafafa" v-for="comment in tickets.details?.comments">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="user d-flex flex-row align-items-center">
                      <img :src="comment.user_image || '/assets/lms_website/images/user.png'" width="30" class="user-img rounded-circle mr-2"/>
                      <span><small class="font-weight-bold text-primary">{{ comment.sender }}</small></span>
                    </div>
                    <span class="font-s-12 ms-auto" :tooltip="moment(comment.creation).format('YYYY-MM-DD (HH:mm) A')"><i class="far fa-clock me-1"></i> {{ frappe.datetime.prettyDate(comment.creation, true) }}</span>
                  </div>
                  <div class="comment-content" v-html="comment.content"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>

    <Pagination
        v-if="!tickets.loading && !show_details"
        :current-page="tickets.currentPage"
        :total-items="tickets.list.length"
        :items-per-page="tickets.itemsPerPage"
        @page-changed="handlePageChange"
    />

  </div>
  <!-- dashboard-content-area-end -->
</template>

<script>
import {authData, isLoggedIn} from "../../../utils/auth";
import Pagination from "../../../components/Pagination.vue";

export default {
  name: "Tickets",
  components: {Pagination},
  props: {},
  setup() {
    return {
      frappe,
      moment,
      lms_website,
      isLoggedIn,
      authData
    }
  },
  data() {
    return {
      ticketDialog: null,
      commentDialog: null,
      tickets: {
        loading: true,
        currentPage: 1,
        itemsPerPage: 5,
        list: [],
        details: {}
      },
      show_details: false,
      show_details_loading: true,
    }
  },
  computed: {
    auth() {
      if (this.authData && this.authData().is_logged_in && this.authData().user) {
        return this.authData();
      }
    },
    isStudent() {
      return !!this.auth.student_detail?.name;
    },
    paginatedTickets() {
      const start = (this.tickets.currentPage - 1) * this.tickets.itemsPerPage;
      const end = start + this.tickets.itemsPerPage;
      return this.tickets.list.slice(start, end);
    },
  },
  watch: {},
  methods: {
    get_tickets() {
      if (this.auth.student_detail && this.auth.student_detail.name) {
        this.tickets.loading = true;
        frappe.call({
          type: "GET",
          method: "lms_website.api.user.get_tickets",
          args: {
            student_id: this.auth.student_detail.name
          },
          callback: ({message}) => {
            NProgress.done();
            this.tickets.loading = false;
            this.tickets.list = message;
          },
        });
      } else {
        this.tickets.loading = false;
        this.tickets.list = [];
      }
    },
    refreshTickets() {
      this.get_tickets();
    },
    refreshTicket(ticket_id) {
      this.openTicket(ticket_id);
    },
    openTicket(ticket_id) {
      this.show_details = true;
      this.show_details_loading = true;
      NProgress.start();
      frappe.call({
        type: "GET",
        method: "lms_website.api.user.get_ticket",
        args: {
          ticket_id: ticket_id
        },
        callback: ({message}) => {
          NProgress.done();
          this.show_details_loading = false;
          this.tickets.details = message;
        },
      });
    },
    newTicket() {
      window.location.href = "/home/helpdesk";
      // this.ticketDialog = new frappe.ui.Dialog({
      //   title: lms_website.__('New Ticket'),
      //   fields: [
      //     {
      //       fieldname: 'ticket_name',
      //       label: lms_website.__('Ticket Name'),
      //       fieldtype: 'Link',
      //       options: 'Ticket Name',
      //       reqd: 1,
      //       onchange: () => {
      //         const ticket_name = this.ticketDialog.get_value('ticket_name');
      //         console.log('ticket_name', ticket_name)
      //         if (ticket_name) {
      //           this.ticketDialog.set_df_property('ticket_type', 'hidden', 0);
      //           this.ticketDialog.set_df_property('ticket_type', 'read_only', 0);
      //         } else {
      //           this.ticketDialog.set_value('ticket_type', '');
      //           this.ticketDialog.set_df_property('ticket_type', 'hidden', 1);
      //         }
      //         this.ticketDialog.fields_dict.ticket_type.refresh();
      //       }
      //     },
      //     {
      //       fieldname: 'ticket_type',
      //       label: lms_website.__('Ticket Type'),
      //       fieldtype: 'Link',
      //       options: 'Ticket Type',
      //       reqd: 1,
      //       hidden: 1,
      //       read_only: 1,
      //       // depends_on: 'eval:doc.ticket_name',
      //       get_query: () => {
      //         const ticket_name = this.ticketDialog.get_value('ticket_name');
      //         return {
      //           filters: {
      //             ticket_name: ticket_name
      //           }
      //         };
      //       }
      //     },
      //     {
      //       fieldname: 'subject',
      //       label: lms_website.__('Subject'),
      //       fieldtype: 'Data',
      //       reqd: 1
      //     },
      //     {
      //       fieldname: 'description',
      //       label: lms_website.__('Description'),
      //       fieldtype: 'Text Editor',
      //       reqd: 1
      //     },
      //     {
      //       fieldname: 'attachment',
      //       label: lms_website.__('Attachment'),
      //       fieldtype: 'Attach Image',
      //       reqd: 0
      //     },
      //   ],
      //   primary_action_label: lms_website.__('Submit'),
      //   primary_action: (values) => {
      //     let data = {};
      //     for (let key in values) {
      //       data[key] = values[key];
      //     }
      //     data.student_id = this.auth.student_detail.name;
      //     data.branch = this.auth.student_detail.custom_branch;
      //     frappe.freeze();
      //     frappe.call({
      //       type: "POST",
      //       method: "lms_website.api.user.create_ticket",
      //       args: {
      //         data: data
      //       },
      //       callback: ({message}) => {
      //         this.ticketDialog.hide();
      //         frappe.unfreeze();
      //         this.tickets.loading = true;
      //         setTimeout(() => {
      //           this.get_tickets();
      //         }, 500);
      //       },
      //     });
      //   }
      // }).show();
    },
    newComment() {
      this.commentDialog = new frappe.ui.Dialog({
        title: lms_website.__('New Comment'),
        fields: [
          {
            fieldname: 'comment',
            label: lms_website.__('Comment'),
            fieldtype: 'Text Editor',
            reqd: 1
          },
        ],
        primary_action_label: lms_website.__('Submit'),
        primary_action: (values) => {
          let data = {};
          for (let key in values) {
            data[key] = values[key];
          }
          data.ticket_id = this.tickets.details.name;
          console.log(this.tickets)
          frappe.freeze();
          frappe.call({
            type: "POST",
            method: "lms_website.api.user.create_ticket_comment",
            args: {
              data: data,
            },
            callback: ({message}) => {
              this.commentDialog.hide();
              frappe.unfreeze();
              setTimeout(() => {
                this.tickets.details.comments.unshift(message);
              }, 1000);
            },
          });
        }
      }).show();
    },
    handlePageChange(page) {
      this.tickets.currentPage = page;
    },
    avg_rating_width(value) {
      if (value) {
        return `${((value / 5) * 100)}%`;
      }
      return '0%';
    },
    clip(str, limit) {
      if (!str) return '';
      str = str.toString();
      if (str.length <= limit) {
        return str;
      }
      return str.substr(0, limit) + '...';
    },

    getAttachmentFileName(filename) {
      if (filename) {
        return filename.split('/').pop();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.get_tickets();
      $("[data-background]").each(function () {
        $(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
.tpd-table {
  padding: 20px 30px 20px 30px;
}

.comment-content {
  margin-top: 15px;

  .ql-editor.read-mode {
    font-size: 14px;
  }
}

.badge {
  font-weight: 400 !important;

  &[data-status="In progress"] {
    background-color: #47c2ef !important;
  }

  &[data-status="Open"] {
    background-color: #5d69ea !important;
  }

  &[data-status="Waiting For Info"] {
    background-color: #21ba28 !important;
  }

  &[data-status="Under Review"] {
    background-color: #fc9e33 !important;
  }

  &[data-status="Closed"] {
    background-color: #e41412 !important;
  }

  &[data-status="Reopen"] {
    background-color: #6ca9ff !important;
  }
}
</style>
